import { watch } from 'vue'
import { useProjectionsStore } from '../stores/projections'

/**
 * Composable for managing dynamic page titles based on fixture data
 * 
 * Automatically updates the document title when projections data is loaded,
 * showing "Home Team : Away Team : Date - OddsComposer v2" format.
 * Falls back to base title when no fixture data is available.
 * 
 * @returns {Object} Object containing updateTitle, resetTitle, and baseTitle
 */
export function usePageTitle() {
  const projectionsStore = useProjectionsStore()
  const baseTitle = 'OddsComposer'
  
  // Watch for changes in projections data and update document title
  watch(
    () => projectionsStore.projectionsData,
    (projectionsData) => {
      // Check if we have valid team data
      if (projectionsData?.home_team?.team_name && projectionsData?.away_team?.team_name) {
        const homeTeam = projectionsData.home_team.team_name
        const awayTeam = projectionsData.away_team.team_name
        const gameDate = projectionsData.gamedate || ''
        
        document.title = `${homeTeam} : ${awayTeam} : ${gameDate} - ${baseTitle}`
      } else {
        document.title = baseTitle
      }
    },
    { immediate: true, deep: true }
  )
  
  // Method to manually update title (useful for edge cases)
  const updateTitle = (customTitle) => {
    document.title = customTitle || baseTitle
  }
  
  // Method to reset to base title
  const resetTitle = () => {
    document.title = baseTitle
  }
  
  return {
    updateTitle,
    resetTitle,
    baseTitle
  }
}
